import { render } from "./App.vue?vue&type=template&id=0c6d62c4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0c6d62c4&lang=css"
script.render = render

export default script